import {Colors} from '@eitje/assets'

export const ANTD_THEME = {
	token: {
		colorPrimary: Colors.mediumBlue,
		colorError: Colors.red,
		colorBorder: Colors.mediumBorder,
		borderRadius: 4,
		controlHeight: 40,
		fontFamily:
			"-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
		colorText: Colors.black,
		colorTextPlaceholder: Colors.grey,
	},
	components: {
		Button: {
			fontWeight: 600,
			controlHeight: 40,
			controlHeightLG: 40,
			controlHeightSM: 40,
			paddingInline: '1.2rem',
			primaryShadow: 'none',
			defaultShadow: '0 2px 0 rgba(0, 0, 0, 0.02)',
		},
		DatePicker: {
			padding: 10,
			cellHeight: 24,
			cellWidth: 36,
			textHeight: 40,
		},
		Input: {
			colorBorder: Colors.mediumBorder,
		},
		Select: {
			colorBorder: Colors.mediumBorder,
			controlItemBgActive: Colors.lightGrey,
			multipleItemBg: Colors.lightBlue,
			multipleItemHeight: 28,
			paddingSM: 0,
		},
		Checkbox: {
			controlInteractiveSize: 16,
			colorBorder: Colors.mediumBorder,
		},
		Tooltip: {
			colorBgSpotlight: Colors.tooltip,
			fontSize: 14,
		},
		Modal: {
			headerPadding: '24px 24px',
			contentPadding: 0,
			footerPadding: '16px 24px',
			footerBorderTop: `1px solid ${Colors.mediumBorder}`,
		},
	},
}
